<template>
  <div class="g-content">
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <h3>
          {{ $t('deviceModel_title') }}
        </h3>

        <div class="g-content-filter-right" v-if="!networkError">
          <!-- 添加新模型 -->
          <a-button
            type="primary"
            @click="showModelUpdate('add')"
            icon="plus"
            v-auth="['auth_deviceModel_add']"
          >
            {{ $t('com_btn_add') }}
          </a-button>

          <a-button
            type="primary"
            @click="showModelUpdate('edit')"
            icon="edit"
            v-auth="['auth_deviceModel_edit']"
          >
            {{ $t('com_btn_edit') }}
          </a-button>

          <a-button
            type="special"
            @click="showModelUpdate('fork')"
            icon="fork"
            v-auth="['auth_deviceModel_fork']"
          >
            {{ $t('com_btn_fork') }}
          </a-button>

          <a-button
            type="red"
            @click="deleteModel"
            icon="delete"
            v-auth="['auth_deviceModel_delete']"
          >
            {{ $t('com_btn_delete') }}
          </a-button>
        </div>
      </div>
    </div>

    <div class="g-content-main common-filter-main">
      <div class="config-main" v-if="modelList && modelList.length">
        <div class="config-side">
          <!-- 父模型列表 -->
          <ul>
            <li
              v-for="model in modelList"
              :key="model.devModelId"
              :class="
                currentModel &&
                (currentModel.devModelId === model.devModelId ||
                  currentModel.parentId === model.devModelId)
                  ? 'open'
                  : ''
              "
              :title="model.name"
            >
              <div
                class="mode-list-title"
                :class="
                  currentModel && currentModel.devModelId === model.devModelId ? 'open active' : ''
                "
                @click="getModelDetail(model.devModelId)"
              >
                <DeviceAvatar :avatarType="model.avatar" v-if="model.avatar" />
                <Icon type="menu_device_model" v-else />
                <span>{{ model.name }}</span>
              </div>
              <ul v-if="model.children && model.children.length">
                <li v-for="child in model.children" :key="child.devModelId" :title="child.name">
                  <div
                    class="mode-list-title"
                    @click="getModelDetail(child.devModelId)"
                    :class="
                      currentModel && currentModel.devModelId === child.devModelId ? 'active' : ''
                    "
                  >
                    <DeviceAvatar :avatarType="child.avatar" v-if="child.avatar" />
                    <a-icon type="tag" v-else />
                    <span>{{ child.name }}</span>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="model-content">
          <Loading :show="loading" v-if="loading" />
          <div v-else style="height:100%;min-height:100%;">
            <div class="content-baseinfo" v-if="currentModel">
              <div class="content-baseinfo-content">
                <h2>
                  <span>{{ $t('deviceMode_base_title') }}</span>
                </h2>

                <div class="content-baseinfo-list">
                  <div class="content-baseinfo-img">
                    <ImageSlider :listData="currentModel?.icons" />
                  </div>
                  <div
                    class="content-baseinfo-item"
                    :style="currentModel.description ? 'max-with:400px' : ''"
                  >
                    <ul v-if="currentModel">
                      <li>
                        <label>{{ $t('deviceModel_table_name') }}：</label
                        ><span
                          ><b>{{ currentModel.name }}</b></span
                        >
                      </li>
                      <li v-if="currentModel.supportWeb || currentModel.supportSsh">
                        <label>{{ $t('deviceModel_table_web_ssh') }}：</label>
                        <span>
                          {{ currentModel.supportWeb ? $t('deviceModel_table_web') : '' }}
                          {{
                            currentModel.supportSsh
                              ? (currentModel.supportWeb ? '/' : '') +
                                ' ' +
                                $t('deviceModel_table_ssh')
                              : ''
                          }}
                        </span>
                      </li>

                      <li v-if="createEvent">
                        <label>{{ $t('com_table_created') }}：</label>
                        <span class="g-username">
                          {{ createEvent.executeUser }}
                        </span>
                      </li>

                      <li v-if="updateEvent">
                        <label>{{ $t('com_table_created_time') }}</label>
                        <span> {{ createEvent?.executeTime | formatDate }}</span>
                      </li>

                      <li v-if="updateEvent">
                        <label>{{ $t('com_table_updated_time') }}：</label>
                        <span>
                          {{ updateEvent?.executeTime | formatDate }} by
                          <i class="g-username">{{ updateEvent.executeUser }}</i>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="content-item-container"
              v-auth="[
                'auth_deviceModel_config',
                'auth_deviceModel_param',
                'auth_deviceModel_ctrl',
              ]"
            >
              <a-tabs
                default-active-key="1"
                :activeKey="activeKey"
                :animated="false"
                type="card"
                @change="tabsChange"
              >
                <a-tab-pane
                  key="1"
                  :tab="$t('deviceMode_config_title')"
                  v-if="authList.includes('auth_deviceModel_config') || isSuperAdmin"
                >
                  <ConfigList
                    :allGroup="configModelGroupList"
                    :currentModel="currentModel"
                    :updateFn="showItemUpdate"
                    :scrollEvent="scrollEvent"
                    ref="tabConfigList"
                    v-if="activeKey === '1'"
                  />
                </a-tab-pane>
                <a-tab-pane
                  key="2"
                  :tab="$t('deviceMode_params_title')"
                  force-render
                  v-if="authList.includes('auth_deviceModel_param') || isSuperAdmin"
                >
                  <ParamsList
                    :allGroup="configModelGroupList"
                    :currentModel="currentModel"
                    :updateFn="showItemUpdate"
                    :scrollEvent="scrollEvent"
                    ref="tabParamsList"
                    v-if="activeKey === '2'"
                  />
                </a-tab-pane>

                <a-tab-pane
                  key="3"
                  :tab="$t('deviceMode_control_title')"
                  force-render
                  v-if="authList.includes('auth_deviceModel_ctrl') || isSuperAdmin"
                >
                  <ControlList
                    :allGroup="configModelGroupList"
                    :currentModel="currentModel"
                    :updateFn="showItemUpdate"
                    :scrollEvent="scrollEvent"
                    ref="tabControlList"
                    v-if="activeKey === '3'"
                  />
                </a-tab-pane>
              </a-tabs>
            </div>
          </div>
        </div>
      </div>
      <NetworkError v-else-if="networkError" style="margin-top:0;" />
      <Empty v-else />
    </div>

    <!-- 添加/编辑 Model -->
    <ModelUpdate
      ref="deviceUpdate"
      :parentModelList="modelList"
      :callback="
        devModelId => {
          if (devModelId) {
            this.getModelDetail(devModelId);
          } else {
            this.getGroupList(devModelId);
          }
        }
      "
    />

    <!-- 添加/编辑 Model -->
    <ConfigItemUpdate
      ref="configUpdate"
      :updateType="updateType"
      :groupList="configModelGroupList"
      :parentModelList="modelList"
      :modelList="modelList"
      :callback="configUpdateCallback"
      v-if="currentModel"
    />

    <!-- 添加/编辑 控制命令 -->
    <ControlItemUpdate
      ref="controlItemUpdate"
      :updateType="updateType"
      :groupList="configModelGroupList"
      :parentModelList="modelList"
      :modelList="modelList"
      :callback="configUpdateCallback"
      v-if="currentModel"
    />
  </div>
</template>
<script>
import * as API from '@/api/system/model';
import * as APIConfig from '@/api/system/config';
import { makeTree, dragTableToScroll } from '@/libs/utils';
import Config from '@/config';

import ModelUpdate from './components/modelUpdate.vue';
import ConfigItemUpdate from './components/configItemUpdate.vue';
import ConfigList from './components/configList.vue';
import ParamsList from './components/paramsList.vue';
import ControlList from './components/controlList.vue';

import ControlItemUpdate from './components/controlItemUpdate.vue';

import { mapGetters } from 'vuex';

export default {
  components: {
    ModelUpdate,
    ConfigItemUpdate,
    ConfigList,
    ParamsList,
    ControlList,
    ControlItemUpdate,
  },
  data() {
    return {
      Config,
      loading: true,
      modelList: [],
      // 当前Group
      currentModel: null,
      createEvent: null,
      updateEvent: null,
      configModelGroupList: [],
      updateType: 'config',
      networkError: false,
      activeKey: '1',
      horizontalScroll: null,
    };
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),
  },
  created() {
    // 是否有指定modelID
    if (this.$route && this.$route.params && this.$route.params.id) {
      this.getGroupList(this.$route.params.id);
    } else {
      this.getGroupList();
    }
  },
  beforeDestroy() {
    this.horizontalScrollDestory();
  },
  methods: {
    // 获取model list
    getGroupList(devModelId) {
      this.networkError = false;
      API.DeviceModelListAll()
        .then(res => {
          if (res.code === 0) {
            const treeObj = makeTree({
              data: res.data || [],
              idName: 'devModelId',
              parentIdName: 'parentId',
            });
            this.modelList = treeObj.array;
            if (this.modelList && this.modelList.length) {
              if (devModelId) {
                this.getModelDetail(devModelId);
              } else {
                this.getModelDetail(this.modelList[0].devModelId);
              }
            }
          }
        })
        .catch(err => {
          console.log('err', err);
          if (!/cancelled/gi.test(err)) {
            this.networkError = true;
          }
        })
        .finally(() => {
          this.loading = false;
          this.$store.commit('setPageLoading', false);
        });
    },

    // 获取model详情
    getModelDetail(devModelId) {
      // group是否为空？
      if (!this.modelList.length) {
        this.getGroupList();
        return;
      }

      this.loading = true;
      if (!this.currentModel) {
        this.currentModel = {};
      }
      this.currentModel.devModelId = devModelId;

      API.DeviceModelDetail({
        devModelId: devModelId || this.currentModel.devModelId,
      })
        .then(res => {
          if (res.code === 0) {
            this.loading = false;
            this.currentInfo = res.data;
            this.currentModel = res.data.model;
            this.createEvent = res.data.createEvent;
            this.updateEvent = res.data.updateEvent;

            // 获取配置模型group列表
            this.getAllConfigModelGroupList();
          }
        })
        .finally(() => {
          this.loading = false;
          this.$store.commit('setPageLoading', false);
        });
    },

    // 编辑model
    showModelUpdate(type) {
      this.$refs.deviceUpdate.show(
        type,
        type === 'edit' || type === 'fork' ? this.currentModel : null
      );
    },

    // 删除model
    deleteModel() {
      const _this = this;
      const h = this.$createElement;
      this.$confirm({
        title: this.$t('deviceModel_confirm_delete_title'),
        content: h('div', {}, [
          h(
            'p',
            this.$t('deviceModel_confirm_delete_title', {
              name: this.currentModel.name,
            })
          ),
        ]),
        centered: true,
        onOk: () => {
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));

          API.DeviceModelDelete({ devModelId: this.currentModel.devModelId })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));

                // 重新获取列表
                this.getGroupList();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 获取配置模型Group列表
    getAllConfigModelGroupList() {
      if (this.configModelGroupList && this.configModelGroupList.length) {
        this.configUpdateCallback('config');
        this.configUpdateCallback('params');
        this.configUpdateCallback('control');
      } else {
        APIConfig.ConfigGroupList().then(res => {
          if (res.code === 0) {
            this.configModelGroupList = res.data;

            this.configUpdateCallback('config');
            this.configUpdateCallback('params');
            this.configUpdateCallback('control');
          }
        });
      }
    },

    // 添加/编辑config item
    showItemUpdate(configType, record, fork) {
      this.updateType = configType;

      if (configType === 'control') {
        this.$refs.controlItemUpdate.show(this.currentModel, record, fork);
      } else {
        this.$refs.configUpdate.show(this.currentModel, record, fork);
      }
    },

    tabsChange(value) {
      console.log('value', value);
      this.activeKey = value;
      this.selectedRowKeys = [];
    },

    scrollEvent() {
      // 表格横向滚动注册
      this.$nextTick(() => {
        this.horizontalScrollDestory();
        this.horizontalScroll = dragTableToScroll(
          document.querySelector('.ant-table-body'),
          document.querySelector('.ant-table-body table')
        );
      });
    },

    // 添加编辑item 回调
    configUpdateCallback(action) {
      this.$nextTick(() => {
        if (action === 'config') {
          this.$refs.tabConfigList && this.$refs.tabConfigList.getList();
        } else if (action === 'params') {
          this.$refs.tabParamsList && this.$refs.tabParamsList.getList();
        } else if (action === 'control') {
          this.$refs.tabControlList && this.$refs.tabControlList.getList();
        } else {
          // control
        }
      });
    },

    // 横向滚动事件注销
    horizontalScrollDestory() {
      if (this.horizontalScroll) {
        this.horizontalScroll.destroy();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
}
.g-content {
  padding: 0;
  .config-main {
    display: flex;
    height: 100%;
    width: 100%;

    .config-side {
      width: 240px;
      min-width: 180px;
      padding: 10px 5px;
      box-sizing: border-box;
      border-right: #eee solid 1px;
      overflow-x: hidden;
      overflow-y: auto;

      ul {
        display: block;
        li {
          cursor: pointer;
          margin-bottom: 5px;

          .mode-list-title {
            display: flex;
            align-items: center;
            font-size: 12px;
            padding: 7px;
            color: #666;

            &.active,
            &.router-link-exact-active {
              color: #fff;
              background: #1838d9;
              border-radius: 5px;
            }

            > svg {
              margin-right: 8px;
              width: 16px;
              height: 16px;
            }

            // icon
            .anticon {
              font-size: 18px;
              transform: scale(0.6);
              margin-right: 8px;
            }
            &:not(.active):hover {
              color: #1838d9;
              cursor: pointer;
              background: #f5f5f5;
              border-radius: 5px;
            }

            span {
              display: block;
              word-break: break-all;
              word-wrap: break-word;
            }
          }

          &.open {
            ul {
              display: block;
            }
          }

          ul {
            display: block !important;
            li {
              .mode-list-title {
                padding-left: 30px;
              }
            }
          }
        }
      }
    }

    .model-content {
      flex: 1;
      padding: 0;
      overflow-x: hidden;
      overflow-y: auto;

      // 基础信息
      .content-baseinfo {
        min-height: 200px;
        .content-baseinfo-content {
          padding: 15px 20px 30px 15px;

          h2 {
            font-size: 18px;
            margin-bottom: 15px;
            display: flex;
            align-items: center;

            span {
              margin-right: 15px;
            }
          }

          .content-baseinfo-list {
            display: flex;
            align-items: flex-start;

            .content-baseinfo-img {
              width: 200px;
              min-width: 200px;
              margin-right: 20px;
              max-height: 260px;
              border-radius: 5px;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              border: #e5e5e5 dashed 1px;

              img {
                width: auto;
                max-width: 100%;
                max-height: 150px;
                // height: 100%;
              }
            }

            .content-baseinfo-item {
              min-width: 240px;
              ul {
                display: flex;
                flex-wrap: wrap;
                margin: 0;

                li {
                  margin-bottom: 10px;
                  width: 100%;
                  font-size: 14px;

                  label {
                    min-width: 45px;
                    color: #999;
                  }

                  span {
                    word-break: break-all;
                    word-wrap: break-word;
                  }

                  &.remark {
                    display: flex;

                    p {
                      word-break: break-all;
                      word-wrap: break-word;
                      max-width: 800px;
                      padding: 0;
                      margin: 0;
                    }
                  }
                }
              }
            }

            .content-baseinfo-remark {
              font-size: 12px;
              margin-left: 40px;

              h3 {
                color: #999;
              }
            }
          }
        }
      }

      // 列表

      ::v-deep .content-item-container {
        height: calc(100% - 300px);
        width: 100%;

        &.config-loading {
          border-top: #eee solid 1px;
        }

        .ant-tabs {
          min-height: 100%;
          // 第一个tab
          .ant-tabs-bar {
            padding: 0 0 0 20px;
            margin: 0;
            background: #fff;

            .ant-tabs-nav {
              .ant-tabs-tab {
                margin: 0 10px 0 0;
              }
              .ant-tabs-tab-active {
                background: #fff;
              }
            }
          }

          .ant-tabs-content {
            min-height: 100%;
          }
        }

        .content-item-main {
          display: flex;
          padding: 20px 0 0 0;
          min-height: 100%;
          height: 100%;

          .content-item-side {
            width: 150px;
            li {
              height: 35px;
              line-height: 35px;
              text-align: center;
              cursor: pointer;
              border: #ddd dotted 1px;
              border-left: none;
              margin-bottom: 5px;
              border-radius: 0 5px 5px 0;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              padding: 0 10px;

              &:hover {
                background: #f9f9f9;
              }

              &.active {
                color: #f5f5f5;
                background: rgba(26, 179, 148, 0.7);
                border-radius: 0 5px 5px 0;
                border: none;
              }
            }
          }

          .content-item-list {
            flex: 1;
            padding: 0 15px;
            margin-bottom: 50px;

            .content-item-btn {
              display: flex;
              align-items: center;
              button {
                margin-right: 15px;
              }

              padding-bottom: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
